import { apiProvider } from "@/services/utilities/Provider";

export const CandidateService = {
    getByRecruitment: (recruitmentId, page = 1, pageSize = 20, statuses = [], isFavourite = null, sortBy = null, sortDirection = null, search = null, createdFrom = null, createdTo = null, scoreMin = null, scoreMax = null, disqualifiedOnly = null, noScore = null) => {
        const params = new URLSearchParams({ page, pageSize });
        statuses.forEach(s => params.append('statuses', s));
        if (isFavourite) params.append('isFavourite', 'true');
        if (sortBy) params.append('sortBy', sortBy);
        if (sortDirection) params.append('sortDirection', sortDirection);
        if (search) params.append('search', search);
        if (createdFrom) params.append('createdFrom', createdFrom);
        if (createdTo) params.append('createdTo', createdTo);
        if (scoreMin != null) params.append('scoreMin', scoreMin);
        if (scoreMax != null) params.append('scoreMax', scoreMax);
        if (disqualifiedOnly) params.append('disqualifiedOnly', 'true');
        if (noScore) params.append('noScore', 'true');
        return apiProvider.get(`/Candidate/recruitment/${recruitmentId}?${params}`);
    },
    getById: (id) => apiProvider.get(`/Candidate/${id}`),
    getConsents: (id) => apiProvider.get(`/chat/consents/candidate/${id}`),
    getEvaluation: (id) => apiProvider.get(`/Candidate/${id}/evaluation`),
    recalculateEvaluation: (id) => apiProvider.post(`Candidate/${id}/evaluation/recalculate`, {}),
    exportXlsx: (recruitmentId, ids = [], statuses = [], isFavourite = null, sortBy = null, sortDir = null, search = null) =>
        apiProvider.downloadPost(`/Candidate/recruitment/${recruitmentId}/export/xlsx`, {
            ids: ids.length ? ids : null,
            statuses: statuses.length ? statuses : null,
            isFavourite: isFavourite || null,
            sortBy,
            sortDirection: sortDir,
            search: search || null,
        }),
    toggleFavorite: (id) => apiProvider.patch(`Candidate/${id}/favorite`, {}),
    changeStatus: (id, status, note = null) => apiProvider.patch(`Candidate/${id}/status`, { status, note }),
    getNotes: (id, sortBy = null, sortDirection = null, search = null) => {
        const params = new URLSearchParams();
        if (sortBy) params.append('sortBy', sortBy);
        if (sortDirection) params.append('sortDirection', sortDirection);
        if (search) params.append('search', search);
        const qs = params.toString();
        return apiProvider.get(`/Candidate/${id}/notes${qs ? `?${qs}` : ''}`);
    },
    addNote: (id, content, files = []) => {
        const formData = new FormData();
        formData.append('content', content);
        files.forEach(f => formData.append('files', f));
        return apiProvider.postMultipart(`Candidate/${id}/notes`, formData);
    },
    getTimeline: (id) => apiProvider.get(`/Candidate/${id}/timeline`),
    addTimelineEntry: (id, kind, description, occurredAt, files = []) => {
        const formData = new FormData();
        formData.append('kind', kind);
        formData.append('description', description);
        formData.append('occurredAt', occurredAt);
        files.forEach(f => formData.append('files', f));
        return apiProvider.postMultipart(`Candidate/${id}/timeline/entries`, formData);
    },
    getAttachments: (id) => apiProvider.get(`/Candidate/${id}/attachments`),
    addAttachments: (id, files = []) => {
        const formData = new FormData();
        files.forEach(f => formData.append('files', f));
        return apiProvider.postMultipart(`Candidate/${id}/attachments`, formData);
    },
    downloadAllAttachmentsZip: (id) =>
        apiProvider.download(`/Candidate/${id}/attachments/zip`),
    downloadAttachment: (id, path) =>
        apiProvider.download(`/Candidate/${id}/attachments/file?name=${encodeURIComponent(path)}`),
    bulkChangeStatus: (candidateIds, newStatus, note = null) =>
        apiProvider.patch(`Candidate/bulk/status`, { candidateIds, newStatus, note }),
    bulkSendEmail: (candidateIds, subject, body, files = []) => {
        const formData = new FormData();
        candidateIds.forEach(id => formData.append('candidateIds', id));
        formData.append('subject', subject);
        formData.append('body', body);
        files.forEach(f => formData.append('files', f));
        return apiProvider.postMultipart(`Candidate/bulk/email`, formData);
    },
    bulkCreateFromInteraction: (interactionIds) =>
        apiProvider.post(`Candidate/bulk/from-interaction`, { interactionIds }),
    getInteractions: (candidateId, page = 1, pageSize = 20, status = null, sortBy = null, sortDirection = null, isFavorite = null, search = null) => {
        const params = new URLSearchParams({ page, pageSize });
        if (status) params.append('status', status);
        if (sortBy) params.append('sortBy', sortBy);
        if (sortDirection) params.append('sortDirection', sortDirection);
        if (isFavorite != null) params.append('isFavorite', isFavorite);
        if (search) params.append('search', search);
        return apiProvider.get(`/Candidate/${candidateId}/interactions?${params}`);
    },
};
